export default function () {
    return typeof window.ga !== 'undefined';
}
